export default class EnvironmentService {
    static isLiveServer() {
        return (
            window.location.href.startsWith('https://vue-boss.333office.nl') ||
            window.location.href.startsWith('https://boss.333office.nl') ||
            window.location.href.startsWith('https://backoffice.333office.nl')
        );
    }
}
